import ReactQuill from 'react-quill';

import QuantityBlot from './QuantityBlot';

// Custom Quill formats for position offer texts. The same formats are rendered to the offer
// PDF by Application/Services/Offers/Common/OfferTextRenderer.cs.

const { Quill } = ReactQuill;
const Parchment = Quill.import('parchment');
const Inline = Quill.import('blots/inline');

// Strikethrough with its own line colour
class StrikeColorBlot extends Inline {
  static blotName = 'strikecolor';

  static tagName = 'span';

  static className = 'ql-strike-color';

  static create(value: string): HTMLElement {
    const node = super.create(value) as HTMLElement;
    node.setAttribute('data-strike-color', value);
    node.style.textDecoration = 'line-through';
    node.style.textDecorationColor = value;
    return node;
  }

  static formats(node: HTMLElement): string | undefined {
    return node.getAttribute('data-strike-color') ?? undefined;
  }
}

// Bullet list marker of a list item (the default bullet is a dot)
const Marker = new Parchment.Attributor.Class('marker', 'ql-marker', {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['dash', 'arrow', 'circle', 'square'],
});

let registered = false;

const registerOfferTextFormats = (): void => {
  if (registered) {
    return;
  }

  Quill.register(
    {
      'formats/marker': Marker,
      'formats/quantity': QuantityBlot,
      'formats/strikecolor': StrikeColorBlot,
    },
    true
  );

  registered = true;
};

const OFFER_TEXT_FORMATS = [
  'align',
  'background',
  'bold',
  'color',
  'indent',
  'italic',
  'list',
  'marker',
  'quantity',
  'size',
  'strikecolor',
  'underline',
];

export { OFFER_TEXT_FORMATS };
export default registerOfferTextFormats;
